export var StatusType;
(function (StatusType) {
    StatusType[StatusType["NETWORK"] = 0] = "NETWORK";
    StatusType[StatusType["OFFLINE"] = 1] = "OFFLINE";
    StatusType[StatusType["GENERAL"] = 2] = "GENERAL";
})(StatusType || (StatusType = {}));
